import { authClient } from './client';
import extractErrorMessage from '../utils/extractErrorMessage';

const aiApi = {
  translate: async (fields, htmlFields = []) => {
    try {
      return (await authClient.post('/ai/translate', { fields, htmlFields })).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Prevod nije uspeo.') };
    }
  },
};

export default aiApi;
